import { render, staticRenderFns } from "./AllChats.vue?vue&type=template&id=765e4160"
import script from "./AllChats.vue?vue&type=script&lang=js"
export * from "./AllChats.vue?vue&type=script&lang=js"
import style0 from "./AllChats.vue?vue&type=style&index=0&id=765e4160&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports